import { j as a, c as s } from "./utils-BdNIfrGQ.js";
import { I as c } from "./Image-Ct1HaCUq.js";
const i = ({
  loading: e = "eager",
  fetchPriority: r = "high",
  className: o,
  ...t
}) => /* @__PURE__ */ a.jsx(
  c,
  {
    ...t,
    className: s("w-full h-full object-cover fixed object-center", o),
    role: "presentation",
    loading: e,
    fetchPriority: r
  }
);
export {
  i as B
};
